import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { verifyOtp } from "../../features/user/userAPI";
import { setUser } from "../../features/user/userSlice";
import bgImage from "../../assets/images/37.png";
import { getRedirectPath, saveAuthToken } from "../../utils/authHeader";

function VerifyUser() {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const location = useLocation();
  const { email } = location.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        document.getElementById(`otp-${index - 1}`)?.focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();

    if (!/^\d+$/.test(pasteData)) return;

    const digits = pasteData.slice(0, 6).split("");
    const newOtp = Array(6).fill("");

    digits.forEach((digit, index) => {
      newOtp[index] = digit;
    });

    setOtp(newOtp);

    const focusIndex = Math.min(digits.length, 5);
    document.getElementById(`otp-${focusIndex}`)?.focus();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const code = otp.join("");

    if (code.length !== 6) {
      toast.error("Please enter all 6 digits of the OTP");
      return;
    }

    if (!email) {
      toast.error("Email not found. Please try registering again.");
      return;
    }

    try {
      const response = await verifyOtp({ otp: code, email });

      if (response?.status === 200) {
        const message = response.data?.message || "OTP verified successfully!";
        toast.success(message);

        const token = response.data?.token;
        const userData =
          response.data?.user || response.data?.setting || response?.data;

        if (token) {
          saveAuthToken(token);
        }

        if (userData) {
          dispatch(setUser(userData));
        }
        const path = getRedirectPath({
          role: userData?.role,
          isOnboardingCompleted: userData?.isOnboardingCompleted,
        });

        navigate(path, { replace: true });
      } else {
        toast.error(response?.data?.message || "Invalid OTP.");
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message || error.message || "An error occurred.";
      toast.error(errorMsg);
    }
  };

  return (
    <main className="main" id="top">
      <div className="container-fluid bg-body-tertiary dark__bg-gray-1200">
        <div
          className="bg-holder bg-auth-card-overlay"
          style={{ backgroundImage: `url(${bgImage})` }}
        />
        <div className="row flex-center position-relative min-vh-100 g-0 py-5">
          <div className="col-11 col-sm-10 col-xl-8">
            <div className="card border border-translucent auth-card">
              <div className="card-body pe-md-0">
                <div className="row align-items-center gx-0 gy-7">
                  <div className="col mx-auto py-14">
                    <div className="auth-form-box">
                      <div className="text-center">
                        <a
                          className="d-flex flex-center text-decoration-none mb-4"
                          href="/"
                        >
                          <img
                            src={
                              localStorage.getItem("phoenixTheme") === "dark"
                                ? "/assets/img/icons/logo.png"
                                : "/assets/img/icons/logo-dark.png"
                            }
                            alt="phoenix"
                            width="150"
                          />
                        </a>

                        <h4 className="text-body-highlight">
                          Enter the verification code
                        </h4>
                        <p className="text-body-tertiary mb-0">
                          An email containing a 6-digit verification code has
                          been sent to <b>{email}</b>
                        </p>

                        <form
                          className="verification-form mt-4"
                          onSubmit={handleSubmit}
                        >
                          <div className="d-flex align-items-center gap-2 mb-3 justify-content-center">
                            {otp.map((digit, index) => (
                              <input
                                key={index}
                                id={`otp-${index}`}
                                className="form-control px-2 text-center"
                                type="text"
                                inputMode="numeric"
                                maxLength={1}
                                value={digit}
                                onChange={(e) =>
                                  handleChange(index, e.target.value)
                                }
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                onPaste={handlePaste}
                              />
                            ))}
                          </div>

                          <button
                            className="btn btn-primary w-100"
                            type="submit"
                          >
                            Verify
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default VerifyUser;
